module.exports = __webpack_public_path__ + "img/ss4.2fabf52c.png";